import { Link } from "react-router-dom";
import { GoLock } from "react-icons/go";

const AuthLayout = ({ children }: any) => {
  return (
    <>
      <div className=" bg-[url(/img/auth-bg.png)] h-screen overflow-auto flex items-start bg-no-repeat
 bg-cover p-5">
            <div className="m-auto">
              {children}
            </div>
      </div>
    </>
  );
};

export default AuthLayout;
